export default {
  header: {
    notes: 'Header in request demo dialog',
    message: 'Request a demo',
  },
  text: {
    notes: 'Text in request demo dialog',
    message:
      'Contact your local SANDVIK Sales Representative for an in-person demonstration of how SAM by Sandvik can help your business.',
  },
};
